import { MathMarkdown } from '@/components/chat/MathMarkdown';
import { ReasoningBlock } from './ReasoningBlock';
import type { EmoviDocMessage as EmoviDocMessageType } from './types';

type EmoviDocMessageProps = {
  message: EmoviDocMessageType;
};

export function EmoviDocMessage({ message }: EmoviDocMessageProps) {
  if (message.role === 'user') {
    return (
      <div className="flex justify-end">
        <div className="rounded-2xl bg-primary px-3 py-2 text-primary-foreground max-w-[38ch] text-sm">
          {message.content}
        </div>
      </div>
    );
  }

  if (message.role === 'reasoning') {
    const reasoningText = typeof message.content === 'string' ? message.content.trim() : '';
    if (!reasoningText) return null;

    return <ReasoningBlock reasoning={reasoningText} />;
  }

  if (message.role === 'assistant') {
    return (
      <div className="space-y-1">
        <p className="text-xs text-muted-foreground">EmoviDoc</p>
        <div className="prose prose-sm max-w-none text-foreground">
          <MathMarkdown>{message.content ?? ''}</MathMarkdown>
        </div>
      </div>
    );
  }

  return null;
}
